/* @flow */

import { rem } from 'polished';

import { baseFontFamily, baseFontSize } from '@e180/ui/lib/token/typography';

export default {
  root: {
    position: 'relative',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',

    width: '100%',
    height: '100%',
    padding: 12,
  },

  title: {
    marginTop: 6,
    marginBottom: 16,
    padding: [0, 30],
  },

  subTitle: {
    marginTop: 28,
    textAlign: 'center',

    fontSize: rem(16, baseFontSize),
    fontFamily: baseFontFamily,
  },

  options: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',

    marginTop: 30,
    width: 280,
  },

  option: {
    marginBottom: 8,
  },
};
